<template>
    <div class="Office" v-if="lang">
        <md-whiteframe class="shadow shadow-faint">
            <div class="search search--field">
                <div class="icon">
                    <md-icon>search</md-icon>
                </div>
                <div class="input">
                    <input type="text" v-model="search.query" :placeholder="translate.pages.office.index.search" style="outline:0;" data-step="4" data-intro="Escribe el nombre de la Consulta, se realizara automaticamente">
                    <span class="status">{{ searchIndicator }}</span>
                </div>
                <md-button data-step="1" data-intro="Presiona el Boton de Añadir Consulta" v-if="addButton" class="md-icon-button md-raised button" @click.native="addOffice">
                    <md-icon>add</md-icon>
                </md-button>
                <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeOffices">
                    <md-icon>clear</md-icon>
                </md-button>
            </div>
        </md-whiteframe>
        <div class="table table--office table-mobile has-status table--queries">
            <md-table-card v-if="offices.length > 0" class="table--wrap">
                <div v-if="disabledRegion">
                    <div class="sk-rotating-plane"></div>
                </div>
                <div v-else>
                    <md-table md-sort="name" @sort="onSort" md-sort-by="name" @select="onSelect">
                        <md-table-header>
                            <md-table-row>
                                <md-table-head class="td-sort-name center-mobile" md-sort-by="name">{{translate.pages.office.index.fields.name}}</md-table-head>
                                <md-table-head class="hidden-mobile" md-sort-by="street">{{translate.pages.office.index.fields.address}}</md-table-head>
                                <md-table-head class="hidden-mobile">{{translate.pages.office.index.fields.schedule}}</md-table-head>
                                <md-table-head md-sort-by="active" class="text-center hidden-mobile">{{translate.pages.office.index.fields.status}}</md-table-head>
                                <md-table-head class="text-center hidden-mobile">{{translate.pages.office.index.fields.actions}}</md-table-head>
                            </md-table-row>
                        </md-table-header>
                        <md-table-body>
                            <md-table-row v-for="(row, rowIndex) in offices" :key="rowIndex" :md-item="row" md-selection>
                                <md-table-cell class="name--cell">
                                    <div class="img">
                                        <span class="mini_cover_image" :style="'background-image: url('+ srcImage(row.path)+');'"></span>
                                    </div>
                                    <span class="name">{{ row.name }}</span>
                                    <span class="subname visible-mobile">{{ row.street }} {{ row.number }}, {{row.comunity}}</span>
                                </md-table-cell>
                                <md-table-cell class="hidden-mobile">
                                    <span class="hidden-mobile">{{ row.street }} {{ row.number }}, {{row.comunity}}</span>
                                </md-table-cell>
                                <md-table-cell class="hidden-small">
                                    <span v-if="row.schedules.length == 0">{{translate.pages.office.index.hour_no_define}}</span>
                                    <span v-else>{{ row.schedules[0].turns_active | formatDays }}</span>
                                </md-table-cell>
                                <md-table-cell class="static-mobile">
                                    <div class="enabled" :class="{ 'active' : row.active }">{{ row.active | formatEnabled }}</div>
                                </md-table-cell>
                                <md-table-cell class="actions">
                                     <md-icon class="icon-edit raised"  @click.native="openDialog('tasks', row, rowIndex)">attach_money</md-icon>
                                    <md-icon class="icon-edit raised" :data-step="rowIndex === 0 ? 2 : ''" data-intro="Presiona el Boton de Editar" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                    <md-icon class="icon-delete raised" :data-step="rowIndex === 0 ? 3 : ''" data-intro="Presiona el Boton de Eliminar" @click.native="remove(row, rowIndex)">delete</md-icon>
                                </md-table-cell>
                            </md-table-row>
                        </md-table-body>
                    </md-table>
                    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
                        :md-click-outside-to-close="close"
                        :md-esc-to-close="close">
                        <md-dialog-content>
                            <h3 class="dialog--title">{{translate.pages.office.edit.title}}</h3>
                            <hr>
                            <div class="content-main">
                                <md-layout md-gutter class="modal-wrap">
                                    <md-layout md-flex-small="100" md-flex="30" class="container">
                                        <div class="picture">
                                            <img :src="path" style="max-height:160px;">
                                            <div class="icon camera_upload" @click="uploadAvatarIcon">
                                                <md-icon>photo_camera</md-icon>
                                            </div>
                                        </div>
                                        <span class="md-error" style="width: 100%;display: block;text-align: center;margin-top: 20px;color: red;">{{ errors.hasOwnProperty('formAvatar') && errors.formAvatar.length > 3 ? errors.formAvatar : '' }}</span>

                                        <form id="formAvatar" style="display:none;" method="POST" enctype="multipart/form-data">
                                            <input id="fileAvatar" type="file" name="avatar" @change="onAvatarChange">
                                            <button type="submit"></button>
                                        </form>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="70" class="container">
                                        <div class="multiple checkbox-list" :class="{ 'error' : errors.speciality.invalid }">
                                            <p class="title">{{translate.pages.office.edit.fields.specialities}}</p>
                                            <div class="select">
                                                <md-checkbox class="option" v-for="speciality in specialities" :key="speciality.id" @change="onChosen($event,speciality.id)" v-model="speciality.checked">{{ speciality.name }}</md-checkbox>
                                            </div>
                                            <span class="md-error" v-if="errors.speciality.invalid">{{ errors.speciality.msg }}</span>
                                        </div>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                                            <label>{{translate.pages.office.edit.fields.name}}</label>
                                            <md-input type="text" v-model="currentOffice.name"></md-input>
                                            <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container h10">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.duration.invalid }">
                                            <md-icon>query_builder</md-icon>
                                            <label>{{translate.pages.office.edit.fields.duration}}</label>
                                            <md-input disabled class="forcedisabled" type="number" v-model="currentOffice.duration"></md-input>
                                            <span class="md-error" v-if="errors.duration.invalid">{{ errors.duration.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container md-input-container" style="margin-bottom: 27px !important;">
                                        <vue-select
                                            :options="regions"
                                            placeholder="Provincia"
                                            :on-change="changeRegion"
                                            v-model="currentOffice.region.label"
                                            style="width: 100%;"
                                            class="md-input select2"
                                            >
                                            <span slot="no-options">No se encontraron resultados.</span>
                                        </vue-select>
                                        <span class="md-error" v-if="errors.region_id.invalid">{{ errors.region_id.msg }}</span>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container md-input-container" style="margin-bottom: 27px !important;">
                                        <vue-select
                                            :options="comunities"
                                            placeholder="Comuna"
                                            :on-change="changeCity"
                                            v-model="currentOffice.city.label"
                                            style="width: 100%;"
                                            class="md-input select2"
                                            >
                                            <span slot="no-options">No se encontraron resultados.</span>
                                        </vue-select>
                                        <span class="md-error" v-if="errors.comunity.invalid">{{ errors.comunity.msg }}</span>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.street.invalid }">
                                            <label>{{translate.pages.office.edit.fields.street}}</label>
                                            <md-input type="text" v-model="currentOffice.street"></md-input>
                                            <span class="md-error" v-if="errors.street.invalid">{{ errors.street.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.number.invalid }">
                                            <label>{{translate.pages.office.edit.fields.number}}</label>
                                            <md-input type="text" v-model="currentOffice.number"></md-input>
                                            <span class="md-error" v-if="errors.number.invalid">{{ errors.number.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.phone.invalid }">
                                            <label>{{translate.pages.office.edit.fields.phone}}</label>
                                            <md-input type="text" v-model="currentOffice.phone"></md-input>
                                            <span class="md-error" v-if="errors.phone.invalid">{{ errors.phone.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.hour_confirm.invalid }">
                                            <label>{{translate.pages.office.edit.fields.hour_confirm}}</label>
                                            <md-input type="text" v-model="currentOffice.hour_confirm"></md-input>
                                            <span class="md-error" v-if="errors.hour_confirm.invalid">{{ errors.hour_confirm.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                    <md-layout md-flex-small="100" md-flex="50" class="container">
                                        <md-input-container :class="{ 'md-input-invalid' : errors.active.invalid }">
                                            <label for="active">{{translate.pages.office.edit.fields.status}}</label>
                                            <md-select id="active" v-model="currentOffice.active">
                                                <md-option :key="1" :value="1">{{translate.pages.office.edit.fields.status_option.able}}</md-option>
                                                <md-option :key="0" :value="0">{{translate.pages.office.edit.fields.status_option.disable}}</md-option>
                                            </md-select>
                                            <span class="md-error" v-if="errors.active.invalid">{{ errors.active.msg }}</span>
                                        </md-input-container>
                                    </md-layout>
                                </md-layout>
                            </div>
                        </md-dialog-content>
                        <md-dialog-actions class="modal--footer">
                            <md-button style="padding: 0 15px;" class="float-l md-primary sm-size md-size btn--cancel" @click.native="closeDialog('edit')">{{translate.pages.office.edit.cancel}}</md-button>
                            <md-button style="padding: 0 15px;" class="float-r md-primary sm-size md-size btn--blue" @click.native="closeDialog('edit', true)" :disabled="process">{{translate.pages.office.edit.save}}</md-button>
                        </md-dialog-actions>
                    </md-dialog>
                </div>
            </md-table-card>
            <div v-else>
                <h3 class="not-found mini-found" v-if="search.isQuery">{{translate.pages.office.index.no_name_result}} "<strong>{{ search.query }}".</strong></h3>
                <h3 v-else>
                    <span class="not-found mini-found" v-if="fetchData">{{translate.pages.office.index.no_records}}</span>
                    <span v-else>
                        <div class="sk-rotating-plane"></div>
                    </span>
                </h3>
            </div>
        </div>
        <div style="height:40px;display:block;width:100%"></div>
        <md-button class=" md-raised button" style="background: #96c972; color: white; position: fixed; bottom: 10px; right: 10px;z-index:10000" @click.native="openHelper">
            Tutor Interactivo <md-icon>help</md-icon>
        </md-button>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="helper"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>
                <h3 class="dialog--title">Tutor Interactivo</h3>
                <hr>
                <div class="content-main">
                    <md-layout md-gutter class="modal-wrap">
                    Seleccione un proceso:<br>
                    <md-button class="md-raised md-primary" style="width:100%" @click.native="launchTutor(1)">Crear Una Consulta</md-button>
                    <md-button :disabled="offices.length ==0" class="md-raised md-primary" style="width:100%" @click.native="launchTutor(2)">Editar Una Consulta</md-button>
                    <md-button :disabled="offices.length ==0" class="md-raised md-primary" style="width:100%" @click.native="launchTutor(3)">Eliminar Una Consulta</md-button>
                    </md-layout>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="modal--footer">
                <md-button style="padding: 0 15px;" class="float-l md-primary sm-size md-size btn--cancel" @click.native="closeHelper">{{translate.pages.office.edit.cancel}}</md-button>
            </md-dialog-actions>
        </md-dialog>



        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="tasks"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>
                <h3 class="dialog--title">Prestaciones de la consulta</h3>
                <hr>
                <div class="content-main">
                    <md-layout md-gutter class="modal-wrap">
                    <md-list class="task_list">
                        <md-list-item v-if="currentOffice.tasks.length == 0">
                            Sin Prestaciones en venta
                        </md-list-item>
                        <md-list-item class="table_header">
                            <div class="pseudo_table w50">
                                <b>Prestacion</b>
                            </div>
                            <div class="pseudo_table w25">
                           <b>CoPago Fonasa</b>
                            </div>
                            <div class="pseudo_table w25">
                            <b>Precio Particular</b>
                            </div>

                        </md-list-item>
                        <md-list-item v-for="(row, rowIndex) in currentOffice.tasks" :key="row.id">
                            <div class="pseudo_table w50 is_name">
                                 <md-icon class="icon-delete raised delete_presta" @click.native="removePrestation(row, rowIndex)">delete</md-icon>
                                <b>{{row.task.code}}</b>-{{row.task.name}}
                                <div class="data-mobile">
                                    <b>CoPago Fonasa</b>
                            ${{row.fonasa_price}}
                            <br>
                                <b>Precio Particular</b>
                            ${{row.particular_price}}


                                </div>
                            </div>
                            <div class="pseudo_table w25 is_data">
                            ${{row.fonasa_price}}
                            </div>
                            <div class="pseudo_table w25 is_data">
                            ${{row.particular_price}}
                            </div>

                        </md-list-item>

                    </md-list>
                    <md-button class="md-raised md-primary" style="width:100%" @click.native="openDialog('addTask', currentOffice)">Añadir una Prestación</md-button>

                    </md-layout>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="modal--footer">
                <md-button style="padding: 0 15px;" class="float-l md-primary sm-size md-size btn--cancel" @click.native="closeDialog('tasks')">{{translate.pages.office.edit.cancel}}</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="addTask"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>
                <h3 class="dialog--title">Añadir Prestacion</h3>
                <hr>
                <div class="content-main">
                    <md-layout md-gutter class="modal-wrap">
                        <md-input-container :class="{ 'md-input-invalid' : false }">
                                            <label>Codigo FONASA de Prestación</label>
                                            <md-input type="text" v-model="addTaskData.task_code"></md-input>
                                            <span class="md-error" v-if="false"></span>
                                        </md-input-container>
                                        <div style="width:100%;     background: #f6f6f6;    padding: 10px;" v-if="isTasked()">
                                            Ya tienes esta Prestación, si deseas actualizar los precios elimina la Prestación anterior primero.
                                        </div>
                                        <div style="width:100%;     background: #f6f6f6;    padding: 10px;" v-if="addTaskData.bonus_task && !isTasked()">
                                            <b>Prestación: </b> {{ addTaskData.bonus_task.name }}<br>
                                            <b>CoPago FONASA:</b> ${{  addTaskData.bonus_task.previsions[0].pivot.final_price }}
                                            <hr>
                                            <b>Defina sus precios (CLP):</b><br>
                                            <md-input-container :class="{ 'md-input-invalid' : false }">
                                            <label>CoPago FONASA</label>
                                             <md-select style="width:100%" v-model="addTaskData.copago_amplifier">
                                                <md-option value="1" selected>CoPago sin adicional</md-option>
                                                <md-option value="2">2 veces el CoPago</md-option>
                                                <md-option value="3">3 veces el CoPago</md-option>
                                                <md-option value="4">4 veces el CoPago</md-option>
                                                <md-option value="5">5 veces el CoPago</md-option>
                                            </md-select>
                                        </md-input-container>
                                        <md-input-container :class="{ 'md-input-invalid' : false }">
                                            <label>Precio Particular</label>
                                             <md-input type="number" v-model="addTaskData.task_particular_price"></md-input>
                                        </md-input-container>
                                        </div>
                    </md-layout>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="modal--footer">
                <md-button style="padding: 0 15px;" class="float-l md-primary sm-size md-size btn--cancel" @click.native="closeDialog('addTask')">{{translate.pages.office.edit.cancel}}</md-button>
             <md-button style="padding: 0 15px;" class="float-r md-primary sm-size md-size btn--blue add_task_btn" @click.native="closeDialog('addTask', true)" :disabled="!addTaskData.bonus_task || !addTaskData.task_particular_price || isTasked()">Agregar</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
    const swal = require('sweetalert2');
    import { doctor, public_api } from '../../../config/api.js';
    import axios from 'axios';
    import vueSelect from "vue-select";
    var tour = introJs()
    export default {
        components: {vueSelect},
        data: () => ({
            addTaskData: {
                task_code: '',
                task_particular_price: 0,
                bonus_task: false,
                copago_amplifier: "1"

            },
            currentCopy: {},
            regions: [],
            comunities: [],
            specialities: [],
            offices: [],
            currentOffice: {
                region: {label:'',value:''},
                city: {label:'',value:''},
                comunity: {label:'',value:''},
                tasks: []
            },
            errors: {
                'name': {
                    'invalid': false,
                    'msg': ''
                },
                'street': {
                    'invalid': false,
                    'msg': ''
                },
                'number': {
                    'invalid': false,
                    'msg': ''
                },
                'region_id': {
                    'invalid': false,
                    'msg': ''
                },
                'comunity': {
                    'invalid': false,
                    'msg': ''
                },
                'phone': {
                    'invalid': false,
                    'msg': ''
                },
                'duration': {
                    'invalid': false,
                    'msg': ''
                },
                'hour_confirm': {
                    'invalid': false,
                    'msg': ''
                },
                'speciality': {
                    'invalid': false,
                    'msg': ''
                },
                'active': {
                    'invalid': false,
                    'msg': ''
                },
                'response': {
                    'invalid': false,
                    'msg': ''
                },
                'formAvatar': ""
            },
            selectedData: [],
            fetchData: false,
            currentIndex: -1,
            disabledRegion: true,
            disabled: true,
            close: false,
            addButton: true,
            sort: {},
            page: {},
            search: {
                query: '',
                queryIsDirty: false,
                isCalculating: false,
                isQuery: false
            },
            process: false,
        }),
        computed: {
            // Search indicator
            searchIndicator: function () {
                if (this.search.isCalculating) {
                    return '⟳'
                } else if (this.search.queryIsDirty) {
                    return '...'
                } else {
                    return '✓'
                }
            },
            // Get path office
            path() {
                if(!this.currentOffice.path){
                    return 'https://api.agendaenlinea.cl/image/default_avatar.png';
                }
                return this.currentOffice.path;
            },
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get Lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get User
            user(){
                return this.$store.getters.user;
            }
        },
        created() {
            // Get Offices
            this.$http.get(doctor.api.offices,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.offices = data;
                    this.fetchData = true;
                }).catch(error => {
                    if(!error.response)
                    {
                        if(error.request.status == 0)
                        {
                            this.$router.push({'name':'logout'});
                        }
                    }
                });
            var country = { "country": this.$route.params.country.toUpperCase() };
            // Get Regions
            this.$http.post(doctor.api.regions, country, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    data.map((item, index) => {
                        item.value = item.geonameId;
                        item.label = item.toponymName;
                    });
                    // storage comunities
                    this.regions = data;
                    this.disabledRegion = false;
                    this.disabled = false;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get specialities
           // if(this.user.lang){
                this.getSpeciliaties();
            //}
        },
        methods: {
            isTasked(){
                let is_tasked = this.currentOffice.tasks.filter((x) => {
                    return x.task.code == this.addTaskData.task_code;
                }).length >= 1;
                if(is_tasked) {
                    this.addTaskData.bonus_task = false;
                }
                return is_tasked;
            },
            // Open modal tutor
            launchTutor(step){
                this.closeHelper()
                tour.setOption('tooltipPosition', 'bottom');

                tour.setOption('showButtons', false);
                tour.setOption('showStepNumbers', false);
                tour.setOption('showProgress', false);
                tour.setOption('showBullets', false);
                tour.start();
                if(step){
                    tour.goToStep(step);
                    console.log(step, tour);
                }
            },
            // Get path avatar
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Open Modal
            openDialog(ref, row, rowIndex) {
                let self = this
                this.currentCopy = Object.assign({}, row);
                this.currentIndex = rowIndex;
                this.currentOffice = JSON.parse(JSON.stringify(row));
                this.currentOffice.city = {}
                this.currentOffice.city.label = this.currentOffice.comunity
                this.currentOffice.city.value = ''
                this.currentOffice.specialities.forEach( (speciality) => {
                    this.specialities.forEach( row =>{
                        if(speciality.id == row.id)
                        {
                            row.checked = true;
                        }
                    });
                });
                this.regions.find( region => {
                    if(region.geonameId == this.currentOffice.region_id)
                    {
                        this.currentOffice.region = { label: region.toponymName, value: region.geonameId };
                        this.$http.post(public_api.api.cities, {region: region.geonameId})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                    if(item.toponymName == self.currentOffice.comunity){
                                        self.currentOffice.city = item
                                    }
                                })
                                this.comunities = data
                                this.disabledComunities = false
                                this.$refs[ref].open();
                                this.disabled = false;
                            })
                        return false;
                    }
                });
            },
            // Open helper
            openHelper() {
                let ref = "helper";
                this.$refs[ref].open();
            },
            // Close helper
            closeHelper() {
                let ref = "helper";
                this.$refs[ref].close();
            },
            // Exit helper
            exitHelper() {
               tour.exit(true);
            },
            // Close Modal
            addTask(data){
                let final_data = {
                    office_id: this.currentOffice.id,
                    task_id: this.addTaskData.bonus_task.id,
                    fonasa_price: parseInt(this.addTaskData.bonus_task.previsions[0].pivot.final_price) * parseInt(this.addTaskData.copago_amplifier),
                    particular_price:  parseInt(this.addTaskData.task_particular_price)
                }
                this.$http.post("/doctor/addTask", final_data, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        console.log("new task", response.data.data);
                        this.addTaskData.task_code = "";
                        this.addTaskData.bonus_task = false;
                        this.currentOffice.tasks.push(response.data.data);
                        this.$refs["addTask"].close();

                    })
            },
            closeDialog(ref, save) {
                console.log("cerrando dino", this.currentCopy)
                if(save)
                {
                    if(ref  == "edit") {
                        this.update(ref);
                    } else {
                        this.addTask(ref);
                    }
                }else{

                    this.currentIndex = -1;
                    this.specialities.forEach( row =>{
                        row.checked = false;
                    });
                    this.$refs[ref].close();
                }
            },
            // Route Office add
            addOffice() {
                this.exitHelper();
                this.$router.push({'name': 'OfficeAdd'});
            },
            searchTask(){
                this.addTaskData.bonus_task = false;
                let type = "bonus_task_doctor";
        let data = {type: type}
        let query = this.addTaskData.task_code;
        data.column = 'code'
        data.query = query
        data.is_doctor = true;
        if(!data.query || data.query.length <= 6){
          return;
        }
        this.$http.post("/patient/search", data, {
            headers: {
              Authorization: 'Bearer ' + this.$auth.getToken()
            }
          }).then(response => {
            let data = response.data.data
            console.log(data)
            if(data.length == 1){
             this.addTaskData.bonus_task = data[0]
             this.addTaskData.task_particular_price = parseInt(this.addTaskData.bonus_task.previsions[0].pivot.price);
            } else {
                this.addTaskData.bonus_task = false;
            }

          }).catch(error => {
              this.addTaskData.bonus_task = false;
            console.log(error)
          // alert("No se pudo cargar las comunidades")
          })
            },
            // Show button add
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort offices
            onSort(sort) {
                this.offices = _.orderBy(this.offices, [item => item[sort.name]], sort.type);
            },
            // Paginate
            onPagination(page) {
                this.page = page;
            },
            // Remove office
            remove(row, rowIndex){
                swal(this.translate.pages.office.index.swal.remove.title, this.translate.pages.office.index.swal.remove.message, 'warning')
                    .then( () => {
                        this.$http.delete(doctor.api.offices + '/' + row.id,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.offices.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.offices.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            removePrestation(row, rowIndex){
                console.log("remover prestacion office", row);
                swal(this.translate.pages.office.index.swal.remove.title, "¿Esta seguro de eliminar la Prestación?", 'warning')
                    .then( () => {
                        this.$http.post(doctor.api.remove_presta, {id: row.id},{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                //let data = response.data.data;
                                swal('', "Se ha eliminado con exito", 'success')
                                    .then( () => {
                                        this.currentOffice.tasks.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.currentOffice.tasks.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Remove offices
            removeOffices(){
                swal(this.translate.pages.office.index.swal.removeOffices.title, this.translate.pages.office.index.swal.removeOffices.message, 'warning')
                    .then( () => {
                        var promises = [];
                        for(let index in this.selectedData)
                        {
                            let url = doctor.api.offices + '/' + this.selectedData[index].id;
                            promises.push(this.$http.delete(url, {
                                            headers: {
                                                Authorization : 'Bearer '+ this.$auth.getToken(),
                                            }
                                        }));
                        }
                        Promise.all(promises)
                            .then(values => {
                                var msg = '';
                                var quantites = 0;
                                values.forEach( response => {
                                    if(response.status == 200)
                                    {
                                        msg = response.data.msg;
                                        quantites++;
                                        let url = response.config.url;
                                        let id = url.split("/offices/")[1];
                                        this.offices.forEach( (office,index) => {
                                            if(office.id == id){
                                                this.offices.splice(index,1);
                                            }
                                        });
                                    }else{
                                        // Not deleted
                                    }
                                });
                                swal('', quantites + msg.substring(1), 'success')
                                    .then( () => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    }, (dismiss) => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    });
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Method to search
            expensiveOperation: _.debounce( function() {
                this.search.isCalculating = true;
                let data = {'query': this.search.query, 'type': 'offices'};
                this.$http.post(doctor.api.search, data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.offices = data;
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;
                    this.search.isQuery = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            }, 500),
            // On chosen by speciality
            onChosen(add, speciality_id){
                if(add){
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = true;
                        }
                    });
                    this.currentOffice.specialities.push({"id": speciality_id});
                }else{
                    this.specialities.find( speciality  => {
                        if (speciality.id == speciality_id){
                            speciality.checked = false;
                        }
                    });
                    this.currentOffice.specialities.find( (speciality, index) => {
                        if (speciality.id == speciality_id){
                            this.currentOffice.specialities.splice(index,1);
                        }
                    });
                }
            },
            // Upload avatar
            uploadAvatarIcon(e){
                let icon = document.getElementById('fileAvatar');
                icon.click();
            },
            // Change avatar
            onAvatarChange(e) {
              this.errors.formAvatar = "";
              let formAvatar = document.getElementById('formAvatar');
              console.log(formAvatar);
              var weight = formAvatar.fileAvatar.files[0] ? ((formAvatar.fileAvatar.files[0].size / 1024) / 1024) : 0;
              if(weight >=1){
                this.errors.formAvatar = "Imagen pesa demasiado, limite 1MB";
                return;
              }
              let formData = new FormData(formAvatar);
              formData.append('office', this.currentOffice.id);
              let url = doctor.api.upload.office;
              this.$http.post(url, formData, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        if(response.data.status == "OK"){
                            this.currentOffice.path = response.data.data.path;
                            this.offices[this.currentIndex].path = response.data.data.path;
                        }else{
                            console.log("no se pudo");
                        }
                    }).catch(error => {
                        console.log(error);
                    });
            },
            // Update Office
            update(ref){
                let error = false;
                // validate one
                if(this.currentOffice.name.length == 0)
                {
                    this.errors.name.invalid = true;
                    this.errors.name.msg = this.translate.pages.office.update.validations.name;
                    error = true;
                }else{
                    this.errors.name.invalid = false;
                    this.errors.name.msg = "";
                }
                if(this.currentOffice.street.length == 0)
                {
                    this.errors.street.invalid = true;
                    this.errors.street.msg = this.translate.pages.office.update.validations.street;
                    error = true;
                }else{
                    this.errors.street.invalid = false;
                    this.errors.street.msg = "";
                }
                if(this.currentOffice.number.length == 0)
                {
                    this.errors.number.invalid = true;
                    this.errors.number.msg = this.translate.pages.office.update.validations.number;
                    error = true;
                }else{
                    this.errors.number.invalid = false;
                    this.errors.number.msg = "";
                }
                if(this.currentOffice.comunity.length == 0)
                {
                    this.errors.comunity.invalid = true;
                    this.errors.comunity.msg = this.translate.pages.office.update.validations.comunity;
                    error = true;
                }else{
                    this.errors.comunity.invalid = false;
                    this.errors.comunity.msg = "";
                }
                if(this.currentOffice.phone.length == 0)
                {
                    this.errors.phone.invalid = true;
                    this.errors.phone.msg = this.translate.pages.office.update.validations.phone;
                    error = true;
                }else{
                    this.errors.phone.invalid = false;
                    this.errors.phone.msg = "";
                }
                if(this.currentOffice.specialities.length == 0)
                {
                    this.errors.speciality.invalid = true;
                    this.errors.speciality.msg = this.translate.pages.office.update.validations.speciality;
                    error = true;
                }else{
                    this.errors.speciality.invalid = false;
                    this.errors.speciality.msg = "";
                }
                if(this.currentOffice.duration.length == 0)
                {
                    this.errors.duration.invalid = true;
                    this.errors.duration.msg = this.translate.pages.office.update.validations.duration;
                    error = true;
                }else{
                    this.errors.duration.invalid = false;
                    this.errors.duration.msg = "";
                }
                if(this.currentOffice.hour_confirm.length == 0)
                {
                    this.errors.hour_confirm.invalid = true;
                    this.errors.hour_confirm.msg = this.translate.pages.office.update.validations.hour_confirm;
                    error = true;
                }else{
                    this.errors.hour_confirm.invalid = false;
                    this.errors.hour_confirm.msg = "";
                }
                if(error){
                    return false;
                }
                // udpate Office
                this.process = true;
                this.$http.put(doctor.api.offices + '/' + this.currentOffice.id, this.currentOffice, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.offices[this.currentIndex] = response.data.data;
                        this.currentOffice = {
                            city: {'label':'','value':''},
                            region: {'label':'','value':''}
                        };
                        this.$refs[ref].close();
                        this.specialities.forEach( row =>{
                            row.checked = false;
                        });
                        this.currentIndex = -1;
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        console.log(error);
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
            },
            // Change region
            changeRegion(value){
                if(value){
                    let region = this.regions.find(item => {
                        return item.geonameId == value.geonameId})
                    if(region){
                        this.currentOffice.region.label = region.label
                        this.currentOffice.region.value = region.value
                        this.currentOffice.region_id = region.value
                        this.$http.post(public_api.api.cities, {region: this.currentOffice.region.value})
                            .then(response => {
                                let data = response.data.data
                                data.map(item => {
                                    item.value = item.geonameId
                                    item.label = item.toponymName
                                })
                                this.comunities = data
                                this.currentOffice.city.label = ''
                                this.currentOffice.city.value = ''
                                this.disabledComunities = false
                            })
                    }
                }else{
                    this.comunities = []
                }
            },
            // Change city
            changeCity(value) {
                if(value){
                    if(typeof value != 'string'){
                        let city = this.comunities.find(item => {
                            return item.geonameId == value.geonameId})
                        this.currentOffice.city.label = city.label
                        this.currentOffice.city.value = city.value
                        this.currentOffice.comunity = city.label
                    }
                }else{
                    this.currentOffice.city.label = ''
                    this.currentOffice.city.value = ''
                    this.currentOffice.comunity = ''
                }
            },
            // Get Specialities by language
            getSpeciliaties(update_lang){
                let parent = this.$auth.getParent();
                let url = doctor.speciality.listDoctor + '?country=' + this.$route.params.country;
                if(this.user.lang == null){
                    url += '&lang=' + this.lang;
                }
                if(parent)
                {
                    url += '&parent=' + parent;
                }
                this.$http.post(url, {} ,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    }).then(response => {
                        let data = response.data.data;
                        this.specialities = data;
                    }).catch(error => {
                        console.log(error);
                        //alert("No se pudo cargar las comunidades");
                    });
            }
        },
        watch: {
            'search.query': function () {
                this.search.queryIsDirty = true;
                this.expensiveOperation();
            },
            'addTaskData.task_code' : function(val) {
                if(val && val.length && val.length >=7){
                    this.searchTask();
                }
            },
            'lang': function(val) {
                if(val){
                    this.getSpeciliaties(true);
                }
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/loading.styl'
    .Office
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .button
                background-color color_main
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_error
                    color white
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                -webkit-border-radius 50%
                -moz-border-radius 50%
                border-radius 50%
                position relative
                width 45px
                height 45px
                float left
                overflow hidden
                background transparent
                img
                    width auto
                    min-height 100%
                    min-width 100%
                    height auto
                    left 0
            .name
                margin-left -2px !important
                left 14px !important
                position relative
                top 12px
            .text-center
                text-align center
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
            .enabled
                border 1px solid color_form_placeholder
                border-radius 30px
                color color_form_placeholder
                margin 0 auto
                padding 3px 4px
                text-align center
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
    .content-main
        .container
            padding 0.25em 1em
            .picture
                position relative
                .icon
                    background-color color_main
                    border 3px solid white
                    border-radius 50%
                    bottom -1em
                    cursor pointer
                    height 40px
                    padding 8px
                    position absolute
                    right -1em
                    width 40px
                    text-align center
                    i
                        color white
                        position relative
                        left -3px
                        top -3px
            .multiple
                border 1px solid color_form_border
                border-radius 5px
                width 100%
                .title
                    margin 0.5em
                    color color_form_placeholder
                    &.error
                        border-color color_error !important
                        color rgba(0, 0, 0, .87) !important
                .select
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 110px
                    .option
                        width 95%
                        margin 0.25em
            .subtitle
                margin-top .5em
                color color_form_placeholder
    .mini_cover_image
        width 45px
        height 45px
        display block
        background-size cover
        background-position center
    @media (max-width: 768px)
        .mini_cover_image
            width 50px
            height 50px
    @import '../../../assets/styles/responsive.styl'
</style>
<style>
.btn--cancel {
    color: #ff0000b3 !important;
}
@media (max-width: 790px) {
    .table.table-mobile .table--wrap .img {
    margin-top: 5px !important;
    left: 12px !important;
  }
}
button.add_task_btn:disabled {
    background: #d9f3f6 !important;
}
.pseudo_table {
        display: block;
    background: #f0f0f0;
    height: 60px;
    border: #bdb6b63d inset 0.5px;
    border-collapse: collapse;
    padding: 10px;
    text-align: center;
    line-height: 40px;
}

.pseudo_table.w50 {
    width: 50%;
}

ul.task_list {
    width: 100%;
}

.pseudo_table.w25 {
    width: 25%;
}
.pseudo_table.w50.is_name {
white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 60px;
  height: auto !important;
  line-height: 18px;
  font-size: 13px;
}
.is_name .data-mobile {
  display: none;
}

li.md-list-item.table_header b {
    font-size: 13px !important;
}



@media(max-width: 735px){

.pseudo_table.w50.is_name {
white-space: normal !important;
}
.is_name .data-mobile {
  display: block !important;
}
li.md-list-item.table_header {
    display: none;
}

.pseudo_table.w50.is_name {
    max-height: 200px;
    height: auto;
}

.pseudo_table.w25.is_data {
    display: none;
}

.pseudo_table.w50.is_name {
    width: 100%;
}
}

.delete_presta {
    float: left;
    cursor: pointer;
    color: #e84f4f !important;
}
</style>



// WEBPACK FOOTER //
// Index.vue?32ca9f0f